const telNumbersToLinks = (telsStr: string) => {
    return telsStr.replace(/0[\d ]{8,11}\d/gmi, (match) => {
        return `<a href="tel:${match}">${match}</a>`;
    });
};
export default telNumbersToLinks;
